export default __webpack_public_path__ + "img/9a020ea21e6d8a78edb0f220bb8d30fe.svg";